import { ContentModel } from './ContentModel';
import { VehicleModel } from './VehicleModel';
import { SourceModel } from './SourceModel';
import { ExtraParameterModel } from './ExtraParameterModel';
import { KeywordModel } from './KeywordModel';
import { OrganogramModel } from './OrganogramModel';
import { ClientClipperModel } from './ClientClipperModel';
import { EditAction } from '../shared/enum/EditAction';
import { CutoutModel } from './CutoutModel';
import { ClientIdmConversionRateModel, ClientIrsConversionRateModel } from './SocialMediaRateModel';
import { ClientProductModel } from './ClientProductModel';

export interface ClientModel {
    id: number,
    name: string,
    codeMetric: number | null,
    active: boolean,
    keywords: KeywordModel[],
    contents: ContentModel[],
    vehicles: VehicleModel[],
    sources: SourceModel[],
    extraParameters: ExtraParameterModel[],
    userid: number | null,
    flatOrganogram: OrganogramModel[],
    organograms: OrganogramModel[],
    clientClippers: ClientClipperModel[],
    cutouts: CutoutModel[]
    editAction: EditAction,
    idmConversionRates: ClientIdmConversionRateModel[],
    irsConversionRates: ClientIrsConversionRateModel[],
    primaryColor: string,
    secondaryColor: string,
    imageUrl: string,
    stockSymbol: string,
    products: ClientProductModel[],
    showDashInitialPage: boolean
}

export const clientModelInitial: ClientModel = {
    id: 0,
    name: '',
    codeMetric: null,
    active: false,
    keywords: [],
    contents: [],
    vehicles: [],
    sources: [],
    extraParameters: [],
    userid: 0,
    flatOrganogram: [],
    organograms: [],
    clientClippers: [],
    cutouts: [],
    editAction: EditAction.NONE,
    idmConversionRates: [],
    irsConversionRates: [],
    primaryColor: '',
    secondaryColor: '',
    imageUrl: '',
    stockSymbol: '',
    products: [],
    showDashInitialPage: false
};